import { Component } from '@angular/core';
import { FooterLink } from '@maced/angular-components';

@Component({
  selector: 'app-footer-multi-language',
  templateUrl: './footer-multi-language.component.html',
  styleUrls: ['./footer-multi-language.component.scss']
})
export class FooterMultiLanguageComponent {
  meeUrl = 'https://www.macmillaneducationeverywhere.com';
  logoTarget = '_blank';
  copyrightSpanish = '<span class="c-footer__copy-right--company-name">© Macmillan Educación Limitado 2021 </span><span class="c-footer__copy-right--company-number">Compañía número: 1755588 </span><span class="c-footer__copy-right--vat-number">Número de valor agregado: 199 4406 21</span><span class="c-footer__copy-right--version"> Versión 1.5.5.72</span>';
  copyrightHindi = '<span class="c-footer__copy-right--company-name">© मैकमिलन एजुकेशन लिमिटेड २०२१ </span><span class="c-footer__copy-right--company-number">कंपनी संख्या: १७५५५८८ </span><span class="c-footer__copy-right--vat-number">वैट क्रमांक: १९९ ४४०६ २१</span><span class="c-footer__copy-right--version"> संस्करण 1.5.5.72</span>';

  linksSpanish: FooterLink[] = [
    { label: 'Términos y condiciones', url: this.meeUrl + '/terms-conditions', target: '_blank' , srOnlyLabel:'abrir en nueva ventana'},
    { label: 'Política de cookies', url: 'https://myclasses.macmillaneducationeverywhere.com/MEE/CookiePolicy', target: '_blank', srOnlyLabel:'abrir en nueva ventana' },
    { label: 'Requisitos del sistema', url: this.meeUrl + '/system-requirements', target: '_blank', srOnlyLabel:'abrir en nueva ventana' },
    { label: 'Política de privacidad', url: this.meeUrl + '/privacy-policy', target: '_blank', srOnlyLabel:'abrir en nueva ventana' },
    { label: 'Encabezado modal', url: '/modal-header', target: '_self', srOnlyLabel:'abrir en nueva ventana' },
    { label: 'Para padres', srOnlyLabel:'abrir en nueva ventana' }
  ];

  linksHindi: FooterLink[] = [
    { label: 'नियम और शर्तें', url: this.meeUrl + '/terms-conditions', target: '_blank', srOnlyLabel:'नई विंडो में खोलें' },
    { label: 'कुकीज़ नीति', url: 'https://myclasses.macmillaneducationeverywhere.com/MEE/CookiePolicy', target: '_blank', srOnlyLabel:'नई विंडो में खोलें' },
    { label: 'सिस्टम आवश्यकताएं', url: this.meeUrl + '/system-requirements', target: '_blank', srOnlyLabel:'नई विंडो में खोलें' },
    { label: 'गोपनीयता नीति', url: this.meeUrl + '/privacy-policy', target: '_blank', srOnlyLabel:'नई विंडो में खोलें' },
    { label: 'मोडल हैडर', url: '/modal-header', target: '_self', srOnlyLabel:'नई विंडो में खोलें' },
    { label: 'पालक के लिए', srOnlyLabel:'नई विंडो में खोलें' }
  ];

  selectedLink!: FooterLink;
  onClickLink(link: FooterLink) {
    this.selectedLink = link;
  }
}